import { useEffect, useState } from "react";
import { getPublishedCases } from "../services/publicContent.service";
import { usePublicServerData } from "../context/PublicServerDataContext";
import type { PublishedCaseCard } from "../types/content.types";
import { useLocale } from "@/shared/i18n/locale";

export function usePublishedCases() {
  const serverData = usePublicServerData();
  const locale = useLocale();
  const serverCases = serverData?.cases;
  const initialCases = (serverData?.locale ?? "pt") === locale ? (serverCases ?? []) : [];
  const [cases, setCases] = useState<PublishedCaseCard[]>(() => initialCases);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isMounted = true;
    setIsLoading(true);

    getPublishedCases(locale)
      .then((publishedCases) => {
        if (isMounted) {
          setCases(publishedCases);
        }
      })
      .catch(() => {
        if (isMounted && !serverCases) {
          setCases([]);
        }
      })
      .finally(() => {
        if (isMounted) {
          setIsLoading(false);
        }
      });

    return () => {
      isMounted = false;
    };
  }, [serverCases, locale]);

  return { cases, isLoading };
}
